// AUTO-GENERATED by scripts/convert_phantomx_to_web.py.
// Run `python scripts/convert_phantomx_to_web.py` after editing phantomx/phantomx.xml.

export const PHANTOMX_ASSETS = [
  'phantomx.xml',
  'body_coll.STL',
  'body.STL',
  'connect_coll.STL',
  'connect.STL',
  'thigh_l_coll.STL',
  'thigh_l.STL',
  'tibia_l_coll.STL',
  'tibia_l.STL'
] as const;

export const BODY_GEOMS = {
  'MP_BODY': [
    { mesh: 'body.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'c1_lf': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c1_lm': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c1_lr': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c1_rf': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c1_rm': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c1_rr': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c2_lf': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c2_lm': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c2_lr': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c2_rf': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c2_rm': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'c2_rr': [
    { mesh: 'connect.STL', pos: [0, -0.0252, 0], quat: [1, 0, 0, 0] },
  ],
  'thigh_lf': [
    { mesh: 'thigh_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'thigh_lm': [
    { mesh: 'thigh_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'thigh_lr': [
    { mesh: 'thigh_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'thigh_rf': [
    { mesh: 'thigh_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'thigh_rm': [
    { mesh: 'thigh_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'thigh_rr': [
    { mesh: 'thigh_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'tibia_lf': [
    { mesh: 'tibia_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'tibia_lm': [
    { mesh: 'tibia_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'tibia_lr': [
    { mesh: 'tibia_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'tibia_rf': [
    { mesh: 'tibia_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'tibia_rm': [
    { mesh: 'tibia_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
  'tibia_rr': [
    { mesh: 'tibia_l.STL', pos: [0, 0, 0], quat: [1, 0, 0, 0] },
  ],
} as const;

export const ACTUATOR_NAMES = [
  'j_c1_rf_ctrl',
  'j_thigh_rf_ctrl',
  'j_tibia_rf_ctrl',
  'j_c1_rm_ctrl',
  'j_thigh_rm_ctrl',
  'j_tibia_rm_ctrl',
  'j_c1_rr_ctrl',
  'j_thigh_rr_ctrl',
  'j_tibia_rr_ctrl',
  'j_c1_lf_ctrl',
  'j_thigh_lf_ctrl',
  'j_tibia_lf_ctrl',
  'j_c1_lm_ctrl',
  'j_thigh_lm_ctrl',
  'j_tibia_lm_ctrl',
  'j_c1_lr_ctrl',
  'j_thigh_lr_ctrl',
  'j_tibia_lr_ctrl'
] as const;

export const FOOT_BODY_NAMES = [
  'tibia_rf',
  'tibia_rm',
  'tibia_rr',
  'tibia_lf',
  'tibia_lm',
  'tibia_lr'
] as const;

export const BASE_BODY_NAME = 'MP_BODY';
